export default [
  { title: "Go-Live", icon: "", link: "/docs/go-live" },
  { title: "Go-Live troubleshooting", icon: "", link: "/docs/go-live-troubleshooting" },
  { title: "After Go-Lives", icon: "", link: "/docs/after-go-live" },
];
